import React from 'react';
import { useP } from '../i18n/useP';
import './PersonTh.css';

/* En-tête STANDARD de la colonne « Collaborateur » (décision 2026-08-26).

   Un seul geste partout : on CLIQUE l'en-tête pour trier, on clique l'icône ⇄
   pour inverser l'affichage NOM Prénom ↔ Prénom NOM — et le tri suit ce qu'on
   lit. Remplace les pastilles P↕ / N↕ (`PersonSortToggle`), qui demandaient de
   deviner que deux boutons minuscules portaient le tri d'une colonne.
   Référence d'origine : hub Salaire horaire (LCR), card Salaire horaire.

   Le plus court des appels passe l'objet rendu par `useTableSort` :

     <PersonTh sort={sortApi} className="hr-page__sort-th" />

   Une table qui reçoit son tri en props (sous-composant) passe les valeurs une
   à une : `sortCol` · `sortDir` · `onSort` · `nameOrder` · `onFlip`.

   La disposition de la ligne est en style en ligne À DESSEIN : les en-têtes de
   ces tables portent des règles de largeur et d'empilement propres à chaque
   page (`th > span:first-child { display: block; max-width: 130px }` et
   consorts), qui gagnaient sur une classe. */
export default function PersonTh({
  sort = null,
  sortCol, sortDir, onSort, nameOrder, onFlip,
  label = null,
  className = '',
  ...thProps
}) {
  const p = useP();
  const col = sortCol ?? sort?.sortCol;
  const dir = sortDir ?? sort?.sortDir;
  const key = sort?.personSortKey ?? (nameOrder === 'fn' ? 'first_name_sort' : 'last_name_sort');
  const order = nameOrder ?? sort?.nameOrder ?? 'ln';
  const doSort = onSort ?? sort?.handleSort;
  const doFlip = onFlip ?? sort?.flipNameOrder;
  const isSorted = col === 'first_name_sort' || col === 'last_name_sort';

  return (
    <th
      className={`lk-personth${className ? ` ${className}` : ''}${isSorted ? ' is-sorted' : ''}`}
      onClick={() => doSort && doSort(key)}
      title={p('Cliquer pour trier')}
      {...thProps}
    >
      <span className="lk-personth__row" style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', maxWidth: 'none', whiteSpace: 'nowrap' }}>
        <span>{label || p('Collaborateur')}</span>
        <span className="lk-personth__ind">{isSorted ? (dir === 'asc' ? '↑' : '↓') : '↕'}</span>
        <button
          type="button"
          className="lk-personth__flip"
          title={order === 'fn' ? p('Afficher NOM Prénom') : p('Afficher Prénom NOM')}
          onClick={(e) => { e.stopPropagation(); if (doFlip) doFlip(); }}
        >⇄</button>
      </span>
    </th>
  );
}
